const $doc = $(document);
const clsOrderConfirmation = '.order-confirmation';
const clsPrint = `${clsOrderConfirmation}__title-print`;
const clsProductTitle = '.order-summary--info__title';
const clsLogo = '.nav-logo-img';
const clsSummaryPageLogo = '#edge-park-logo';
const clsPlaceOrder = '.checkout-place-order';
const src = 'src';
const clsAlternateItemName = `${clsOrderConfirmation} ${clsProductTitle}`;

let placeOrderFlag = true;

const checkoutOrderSummary = {
  imageLogoUrl() {
    const imageURL = $(clsLogo).attr(src);
    $(clsSummaryPageLogo).attr(src, imageURL);
  },
  printPage() {
    window.print();
  },
  handlePlaceOrder(e) {
    e.preventDefault();
    if (placeOrderFlag) {
      placeOrderFlag = false;
      let referralCode = window.sessionStorage.getItem('referralCode');
      if (referralCode != null) {
        $('#referralCode_id').val(referralCode);
      }
      $(this)
        .parents('form')
        .submit();
    }
  },
  name() {
    ACC.utility.setEllipsis($(clsAlternateItemName));
  },
 
  init() {
	let obj = this;
    $doc.on('click', clsPrint, this.printPage);
    $doc.on('click', clsPlaceOrder, this.handlePlaceOrder);
    this.name();
    this.imageLogoUrl();
    
	if($('#order-summary-guestCheckout-modal').length > 0){
		let duration  = typeof(orderSummaryGuestCheckoutActivationoverlayTimer) != 'undefined' ? orderSummaryGuestCheckoutActivationoverlayTimer : '3000';
				
		setTimeout(function(){
			ACC.colorbox.open('', {
		        html: $('#order-summary-guestCheckout-modal').html(),
		        onLoad: $('#cboxOverlay').css('position', 'fixed'),
		        width: '376px',
		        height: '230px',
		        title: '',
		        className: 'order-summary-guestCheckout-modal'
		    });
		},parseInt(duration));	
	}
  }
};

checkoutOrderSummary.init();

export default checkoutOrderSummary;
